var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLockedPricing = function SvgLockedPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 65,
    height: 90,
    viewBox: "0 0 65 90"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#76BF43",
    d: "M61.5 34.84h-3.6v-8.59C57.9 11.73 46.3 0 31.94 0 17.6 0 5.98 11.73 5.98 26.25v8.59H2.4A2.41 2.41 0 0 0 0 37.26v50.32A2.41 2.41 0 0 0 2.4 90h59.33c1.32 0 2.4-1.09 2.4-2.42V37.26c-.24-1.33-1.32-2.42-2.64-2.42Zm-50.85-8.71c0-11.86 9.57-21.41 21.17-21.41C43.55 4.72 53 14.4 53 26.13v8.59H10.53v-8.59h.12ZM59.1 85.04H4.55V39.68H59.1v45.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#76BF43",
    d: "M32.5 47.25a9.93 9.93 0 0 0-3.62 19.21v7.44a3.75 3.75 0 0 0 3.75 3.72 3.75 3.75 0 0 0 3.73-3.72v-7.44a9.93 9.93 0 0 0 6.39-9.24 10.33 10.33 0 0 0-10.25-9.97Zm0 15.13a5.13 5.13 0 0 1-5.18-5.16 5.13 5.13 0 0 1 5.18-5.17c2.9 0 5.19 2.28 5.19 5.17a5.13 5.13 0 0 1-5.19 5.16Z"
  })));
};
export default SvgLockedPricing;